import ApiService from "./api.service";
// import ApiMockService from "./api.mock.service"

/**
 * SupplementService es un objeto que almacena las funciones
 *
 * getAllBrand --> función que realiza una petición ._GET al enterpoint, la cual le solicita el listado de marcas
 * retorna el listado de marcas
 *
 * getBrand --> función que realiza una petición GET al enterpoint,la cual le solicita un marca en específico
 * retorna la marca
 *
 *  getCertificationsBrand--> función que realiza una petición GET al enterpoint,la cual le solicita el listado de certificaciones de las marcas
 * retorna las certificaciones
 *
 *
 */

const BrandsService = {
  getAllBrand: async function (params) {
    const response = await ApiService.get("/api/admin/suplement/brands", params);
    // Temporal Local Storage: start
    const itemLS = localStorage.getItem("brands");
    let brandsLS = [];
    if (itemLS) {
      try {
        console.log("Parsing brands from localStorage", itemLS);
        brandsLS = JSON.parse(itemLS);
      } catch (error) {
        console.error("Error parsing brands from localStorage:", error);
        brandsLS = [];
      }
    }
    const allBrands = [...brandsLS, ...(response.data ?? [])];
    return allBrands;
    // Temporal Local Storage: end
    // return response.data ?? [];
  },

  getBrand: async function (id, lang = null) {
    const response = await ApiService.get("api/supplements/brands/" + id, lang);
    return response.data;
  },
  getCertificationsBrands: async function (params) {
    const response = await ApiService.get("api/admin/supplements/certifications-brands", params);
    return response.data;
  },
  /* aca necesitamos armar la ruta */
  deleteGalleryPhoto: async function (photoId) {
    const response = await ApiService._get("/api/admin/food_recipe/delete-gallery-photo", { id: photoId });
    return response.data;
  },
};

export default BrandsService;
